import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EventData, EventPageableResponse } from '@app-model/event';
import { FilterOptions } from '@app-model/filter';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';

import { environment } from '../../environments/environment';
import {SubscribersPageableResponse} from "@app-model/subscribers";

@Injectable({
	providedIn: 'root'
})
export class EventService {
	constructor(private http: HttpClient) {}

	paginate(filter: FilterOptions): Observable<EventPageableResponse> {
		return this.http.post(`${environment.api}/adminEvent/all`, filter).pipe(map(
    (response: EventPageableResponse) => response));
	}

	getEvent(id: number) {
    return this.http.get(`${environment.api}/adminEvent/${id}`).pipe(
			map((response: EventData) => response),
			take(1)
		);
	}
  listEventsSubscribers(filter: FilterOptions): Observable<SubscribersPageableResponse> {
    return this.http.post(`${environment.api}/adminEvent/allEventsSubscribers`, filter).pipe(map(
      (response: SubscribersPageableResponse) => response));
  }

  generatelistEventsSubscribersCSV(filter: FilterOptions) {
    return this.http.post(`${environment.api}/adminEvent/allEventsSubscribersCSV`, filter, {
      responseType: 'blob'
    });
  }



  saveEvent(event: EventData): Observable<EventPageableResponse> {
		return this.http.post(`${environment.api}/adminEvent/save`, event)
    .pipe(map((response: EventPageableResponse) => response));
	}

	removeEvent(event: EventData): Observable<EventPageableResponse> {
		return this.http.post(`${environment.api}/adminEvent/cancel/` + event.id, '')
    .pipe(map((response: EventPageableResponse) => response));
	}
}
